import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class Redocumentacion extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'redocumentacion-concepto/one', saveUrl: 'redocumentacion-concepto/save', backUrl: '/Catalogo/Redocumentaciones' },
      new Form([
        Form.Field('text', 'redocumentacion_concepto', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'redocumentacion_concepto_nombre', 'Descripcion', '', [Validators.required], 8),
      ], ['Guardar'], 'Concepto de Redocumentacion'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Redocumentacion)
